import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userReducer";
import dataReducer from "./dataReducer";
import cartReducer from "./cartReducer";

export const store = configureStore({
    reducer: {
        user: userReducer,
        data: dataReducer,
        cart: cartReducer
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;